import { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { auth } from "../firebaseConfig";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import loginImage from "../assets/login.svg";
import "./Auth.css";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState(localStorage.getItem("rememberedEmail") || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isResetMode, setIsResetMode] = useState(false);
  const [rememberMe, setRememberMe] = useState(
    localStorage.getItem("rememberMe") === "true"
  );

  useEffect(() => {
    if (rememberMe && email) {
      localStorage.setItem("rememberedEmail", email);
    } else {
      localStorage.removeItem("rememberedEmail");
    }
    localStorage.setItem("rememberMe", rememberMe);
  }, [rememberMe, email]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError("Please enter both email and password!");
      return;
    }

    try {
      await signInWithEmailAndPassword(auth, email, password);
      localStorage.setItem("isAuthenticated", "true");
      navigate("/home");
    } catch (error) {
      setError(error.message);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Please enter your registered email!");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset email sent! Check your inbox.");
      setIsResetMode(false); // Switch back to login mode
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="container">
      <div className="d-grid grid-cols-2 main-container">
        {/* Form Container */}
        <div className="form-container d-flex flex-column">
          <h2 className="form-container__title">
            {isResetMode ? "Reset Password" : "Welcome Back!"}
          </h2>
          <p className="form-container__subtitle">
            {isResetMode
              ? "Enter your email to receive a password reset link."
              : "Login and continue your journey with "}
            {!isResetMode && (
              <strong style={{ color: "#ffa500" }}>KaamSaathi</strong>
            )}
          </p>
          <NavLink className="switch-role-btn" to='/'>Switch Role</NavLink>
          {error && <p style={{ color: "red" }}>{error}</p>}

          {!isResetMode ? (
            <form className="mt-3" onSubmit={handleSubmit}>
              <div className="input-container d-flex flex-column">
                <label htmlFor="email" className="input-label">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="input-field"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                />
              </div>
              <div className="input-container d-flex flex-column">
                <label htmlFor="password" className="input-label">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  className="input-field"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                />
                <div className="d-flex align-items-center mt-2">
                  <input
                    type="checkbox"
                    id="rememberMe"
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)}
                  />
                  <label htmlFor="rememberMe" className="remember-me">
                    Remember Me
                  </label>
                </div>
                <p className="mt-2">
                  <span
                    className="text-primary hover"
                    onClick={() => setIsResetMode(true)}
                    style={{ cursor: "pointer" }}
                  >
                    Forgot password?
                  </span>
                </p>
              </div>
              <button type="submit" className="btn-theme">
                Login
              </button>
              {/* <p className="mt-2">
                  <span
                    className="text-primary hover"
                    onClick={() => navigate("/otp-login")}
                    style={{ cursor: "pointer" }}
                  >
                    OTP Login
                  </span>
                </p> */}
            </form>
          ) : (
            <form className="mt-3" onSubmit={handleResetPassword}>
              <div className="input-container d-flex flex-column">
                <label htmlFor="email" className="input-label">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="input-field"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your registered email"
                />
              </div>
              <button type="submit" className="btn-theme">
                Send Reset Email
              </button>
              <p className="mt-2">
                <span
                  className="text-primary hover"
                  onClick={() => setIsResetMode(false)}
                  style={{ cursor: "pointer" }}
                >
                  Back to Login
                </span>
              </p>
            </form>
          )}

          {!isResetMode && (
            <p className="create-account mt-1">
              Don't have an account?{" "}
              <Link to="/signup" className="text-primary">
                SignUp instead
              </Link>
            </p>
          )}
        </div>

        <div className="visual-container bg-primary d-flex flex-column flex-center">
          <h2 className="visual-container__title">
            {isResetMode ? "Secure Your Account" : "Your Security, Our Priority"}
          </h2>
          <h3 className="visual-container__subtitle">
            {isResetMode
              ? "Reset your password with confidence."
              : "Login with confidence knowing your data is protected"}
          </h3>
          <img
            src={loginImage}
            alt="auth visual"
            className="img-responsive visual-container__image"
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
